import React from 'react'

import LineupsTemplate from './LineupsTemplate'

function FixtureLineups({fixture}) {

    return (
        <React.Fragment>
            <div className="row" style={{fontSize: "12px"}}>

                <div style={{width: "50%"}}>

                    {fixture && fixture.lineups && 
                        <LineupsTemplate 
                            lineup={fixture.lineups[`${fixture.homeTeam.team_name}`].startXI} 
                            subs={fixture.lineups[`${fixture.homeTeam.team_name}`].substitutes} 
                        />
                    }

                </div>

                <div style={{width: "50%"}} className="text-right">
                    

                    {fixture && fixture.lineups && 
                        <LineupsTemplate 
                            lineup={fixture.lineups[`${fixture.awayTeam.team_name}`].startXI} 
                            subs={fixture.lineups[`${fixture.awayTeam.team_name}`].substitutes} 
                        />
                    }

                </div>

            </div>
        </React.Fragment>
    )

}
export default FixtureLineups